import React, { useEffect, useState } from "react";
import {
    FloatButton,
    Drawer,
    Select,
    DatePicker,
    Button,
    Skeleton, 
  } from "antd";
  import { SearchOutlined, SettingOutlined } from "@ant-design/icons";
import { useStoreUpdaterWithAPI } from "../../../../../../Hooks/UseStoreUpdaterWithApi";
import { APIConstants } from "../../../../../../Common/APIConstants";
import WaterMeters from "./WaterMeters";
import { calculateDateRangeFromDate } from "../../../../../../Utils/DateConverstion";




const WaterConvertorStatus = () => {
    const {loading, makeRequest } = useStoreUpdaterWithAPI();
    const [open, setOpen] = useState(false);
    const [skip, setSkip] = useState(true);
    const [treeChartInput, setTreeChartInput] = useState("");
    const [meterData, setMeterData] = useState([]);
    // TVSDashBoard/GetWaterConverterStaus?FromDate=2024-08-10&Todate=2024-08-11
    const fetchConvertorStatus = (input) => {
        makeRequest({
          type: APIConstants.GET,
          url: `${APIConstants.GET_FLOW_CONVERTER_DETAILS_WATER }?FromDate=${input.FromDate}&ToDate=${input.ToDate}`,
        }).then((res) => {
          setMeterData(res); 
          console.log(res);
        });
      };
    
      useEffect(() => {
        if (treeChartInput) {
          fetchConvertorStatus(treeChartInput);
        }
      }, [treeChartInput]);

      const setTreeChartInputString = () => { 
        // try {
    
        const currentDate = new Date();
        const { from, to } = calculateDateRangeFromDate(currentDate, 5, 1);
        const treeChartInputData = {
          FromDate: from,
          ToDate: to,
        };
        console.log(treeChartInputData);
    
        const finalInput = treeChartInputData;
        setTreeChartInput(finalInput);
    
        
      };
    
      useEffect(() => {
        setTreeChartInputString();
      }, []);
  return (
    <div>
    <div className="flex justify-center">
      {loading  && (
      <>
        <Skeleton active paragraph={{ rows: 6 }} />
      </>
      )}
      {
        //   isError && (
        // <div className="flex flex-col">
        //   <img className="w-[150px] h-[80px] "  />
        //   <p className="text-sm text-red-500 text-center">Server error</p>
        //   <p className="text-center">Please reload the page</p>
        // </div>
        //   )
      }
    </div>
    {meterData && (
      <div className="flex flex-wrap gap-0">
        {meterData.map((item, index) => (
          <WaterMeters key={index} item={item} />
        ))}
      </div>
    )}
  </div>
  )
}

export default WaterConvertorStatus
